
export default function CTA() {
  const handleCall = () => {
    window.location.href = 'tel:+14384081200';
  };

  const scrollToContact = () => {
    const contactSection = document.getElementById('contact');
    if (contactSection) {
      contactSection.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section 
      className="py-20 bg-cover bg-center bg-no-repeat relative"
      style={{
        backgroundImage: `linear-gradient(rgba(37, 99, 235, 0.9), rgba(59, 130, 246, 0.9)), url('https://readdy.ai/api/search-image?query=Modern%20professional%20cleaning%20team%20working%20in%20bright%20office%20space%2C%20professional%20cleaning%20equipment%20and%20supplies%2C%20team%20collaboration%2C%20high%20quality%20commercial%20photography%2C%20clean%20minimalist%20environment%2C%20blue%20color%20scheme%20accent&width=1920&height=600&seq=cta-background&orientation=landscape')`
      }}
    >
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center text-white">
        <h2 className="text-4xl md:text-5xl font-bold mb-6">
          Prêt à Profiter d'un Service Exceptionnel ?
        </h2>
        <p className="text-xl md:text-2xl mb-8 opacity-90">
          Obtenez votre devis gratuit en moins de 24h et découvrez 
          pourquoi nos clients nous font confiance
        </p>
        
        <div className="flex flex-col sm:flex-row gap-4 justify-center items-center mb-12">
          <button 
            onClick={handleCall}
            className="bg-white text-blue-600 px-8 py-4 rounded-lg text-lg font-semibold hover:bg-gray-100 transition-colors whitespace-nowrap cursor-pointer"
          >
            <i className="ri-phone-fill mr-2"></i>
            438 408 1200
          </button>
          <button 
            onClick={scrollToContact}
            className="bg-yellow-500 text-white px-8 py-4 rounded-lg text-lg font-semibold hover:bg-yellow-600 transition-colors whitespace-nowrap cursor-pointer"
          >
            <i className="ri-mail-line mr-2"></i>
            Devis en Ligne
          </button>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 text-center">
          <div className="flex flex-col items-center">
            <div className="w-16 h-16 bg-white/20 rounded-full flex items-center justify-center mb-4">
              <i className="ri-message-3-line text-2xl"></i>
            </div>
            <h3 className="text-lg font-semibold mb-2">1. Contactez-nous</h3>
            <p className="text-white/80">Par téléphone ou formulaire</p>
          </div>
          
          <div className="flex flex-col items-center">
            <div className="w-16 h-16 bg-white/20 rounded-full flex items-center justify-center mb-4">
              <i className="ri-calculator-line text-2xl"></i>
            </div>
            <h3 className="text-lg font-semibold mb-2">2. Devis Personnalisé</h3>
            <p className="text-white/80">Gratuit et sans engagement</p>
          </div>
          
          <div className="flex flex-col items-center">
            <div className="w-16 h-16 bg-white/20 rounded-full flex items-center justify-center mb-4">
              <i className="ri-check-double-line text-2xl"></i>
            </div>
            <h3 className="text-lg font-semibold mb-2">3. Service Garanti</h3>
            <p className="text-white/80">Intervention rapide et efficace</p>
          </div>
        </div>
      </div>
    </section>
  );
}